module.exports = __webpack_public_path__ + "static/img/14000305.64e99728.png";